import axios from "axios";

export type PostFicherAG2RBody = {
    client: string,
    filename: string,
    payload: string,
};

export type PostFicherAG2RApi = {
    status: string, 
    message: string
};

export type HistoryDocumentAg2rBody = {
    state: boolean,
    documentName: string,
    payload: PostFicherAG2RApi
};

export type PostHistoryDocumentAg2rApi = {
    status: string, 
    message: string
};

export type HistoryDocumentAg2r = {
    id: number,
    loginUser: string,
    userName: string,
    state: "Succeeded" | "failed",
    payload: PostFicherAG2RApi,
    documentName: string,
    createdAt: string,
};

export const postFicherAG2RLidl = async (body: PostFicherAG2RBody): Promise<PostFicherAG2RApi> => {
    return await axios.post(`/arret_travail/upload/documentAg2r`, body);
};

export const postHistoryFicherAG2RLidl = async (body: HistoryDocumentAg2rBody): Promise<PostHistoryDocumentAg2rApi> => {
    return await axios.post('/arret_travail/history/documentAg2r', body);
};

export const getHistoryFicherAG2RLidl = async (): Promise<HistoryDocumentAg2r[]> => {
    return await axios.get('/arret_travail/history/documentAg2r?state=Success&limit=5');
};